module.exports = __webpack_public_path__ + "img/s-hd.d23646f2.jpg";